(function () {
    const header = document.querySelector('.site-header');
    const toggle = document.querySelector('.site-header__toggle');
    const closeBtn = document.querySelector('.site-header__drawer-close');
    const drawer = document.getElementById('site-mobile-menu');
    if (!header || !toggle || !drawer) return;

    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');
    let previouslyFocused = null;
    let previousBodyOverflow = '';

    const focusableElements = () =>
      Array.from(drawer.querySelectorAll(focusableSelector)).filter(
        (element) => !element.hasAttribute('hidden') && element.getClientRects().length > 0,
      );

    const setOpen = (open, restoreFocus = true) => {
      if (open) {
        previouslyFocused = document.activeElement;
        previousBodyOverflow = document.body.style.overflow;
        drawer.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        window.requestAnimationFrame(() => {
          if (closeBtn) closeBtn.focus();
        });
      } else {
        drawer.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = previousBodyOverflow;
        if (restoreFocus && previouslyFocused instanceof HTMLElement) {
          previouslyFocused.focus();
        }
      }
    };

    toggle.addEventListener('click', () => {
      const isOpen = !drawer.hasAttribute('hidden');
      setOpen(!isOpen);
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', () => setOpen(false));
    }

    drawer.addEventListener('click', (e) => {
      if (e.target.closest('a')) setOpen(false);
    });

    document.addEventListener('keydown', (e) => {
      if (drawer.hasAttribute('hidden')) return;

      if (e.key === 'Escape') {
        setOpen(false);
        return;
      }

      if (e.key === 'Tab') {
        const elements = focusableElements();
        if (!elements.length) return;
        const first = elements[0];
        const last = elements[elements.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    const desktopQuery = window.matchMedia('(min-width: 991px)');
    desktopQuery.addEventListener('change', (event) => {
      if (event.matches && !drawer.hasAttribute('hidden')) {
        setOpen(false, false);
        const desktopFocusTarget = header.querySelector('.site-header__brand, .site-header__icon--cart');
        if (desktopFocusTarget instanceof HTMLElement) desktopFocusTarget.focus();
      }
    });

    if (header.classList.contains('site-header--sticky')) {
      const onScroll = () => {
        if (window.scrollY > 8) header.classList.add('is-scrolled');
        else header.classList.remove('is-scrolled');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  })();

if (!customElements.get('footer-accordion')) {
  customElements.define(
    'footer-accordion',
    class FooterAccordion extends HTMLElement {
      constructor() {
        super();
        this.mobileQuery = window.matchMedia('(max-width: 640px)');
        this.syncDisclosureState = this.syncDisclosureState.bind(this);
      }

      connectedCallback() {
        this.disclosures = this.querySelectorAll('.site-footer__column');
        this.syncDisclosureState();
        this.mobileQuery.addEventListener('change', this.syncDisclosureState);
      }

      disconnectedCallback() {
        this.mobileQuery.removeEventListener('change', this.syncDisclosureState);
      }

      syncDisclosureState() {
        this.disclosures.forEach((disclosure) => {
          if (!(disclosure instanceof HTMLDetailsElement)) return;

          const summary = disclosure.querySelector('.site-footer__column-summary');
          if (!summary) {
            disclosure.open = true;
            return;
          }

          disclosure.open = !this.mobileQuery.matches;
          summary.setAttribute('tabindex', this.mobileQuery.matches ? '0' : '-1');
        });
      }
    },
  );
}

document.querySelectorAll('[data-auto-focus]').forEach((element) => {
  element.focus({ preventScroll: true });
});
